import api from "../../../interceptor/Interceptor";
import {
  USER_SELF_UPDATE,
  CONFIRM_PASSWORD,
  SET_PASSWORD,
  FILE_UPLOAD_URL,
  FILE_DELETE,
} from "../../../api/ApiEndpoints";
import {
  updateProfileStart,
  updateProfileSuccess,
  updateProfileFailure,
  uploadImageStart,
  uploadImageSuccessAction,
  uploadImageFailure,
  removeImageStart,
  removeImageSuccessAction,
  removeImageFailure,
  confirmPasswordStart,
  confirmPasswordSuccessAction,
  confirmPasswordFailure,
  changePasswordStart,
  changePasswordSuccessAction,
  changePasswordFailure,
  resetPasswordFlow,
} from "../../reducer/settingReducer/SettingReducer";
import {
  fetchLoginUserSuccess,
  logoutUser as logoutUserAction,
} from "../../reducer/authReducer/AuthReducer";

let isupdateProfile = false;
let isuploadProfileImage = false;
let isremoveProfileImage = false;
let isconfirmCurrentPassword = false;
let ischangePassword = false;

const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

// .................... Update Profile ...........................

export const updateProfile = (profileForm) => async (dispatch, getState) => {
  if (isupdateProfile) return;
  isupdateProfile = true;
  dispatch(updateProfileStart());
  try {
    const response = await api.put(USER_SELF_UPDATE, profileForm);
    dispatch(updateProfileSuccess());

    // Keep navbar/sidebar in sync immediately, without a full session refetch
    const { permissions } = getState().auth;
    dispatch(
      fetchLoginUserSuccess({
        user: response.data?.user || {
          ...getState().auth.user,
          ...profileForm,
        },
        permissions,
      }),
    );
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to update profile");
    dispatch(updateProfileFailure(message));
    return { success: false, error: message };
  } finally {
    isupdateProfile = false;
  }
};

// .................... Profile Image ...........................

export const uploadProfileImage = (file, userEmail) => async (dispatch) => {
  if (isuploadProfileImage) return;
  isuploadProfileImage = true;
  dispatch(uploadImageStart());
  try {
    const { data } = await api.get(
      `${FILE_UPLOAD_URL}?fileName=${encodeURIComponent(
        "user-images/" + userEmail,
      )}&fileType=${encodeURIComponent(file.type)}`,
    );

    const uploadResponse = await fetch(data.uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": file.type },
      body: file,
    });

    if (!uploadResponse.ok) {
      throw new Error(`Upload failed with status ${uploadResponse.status}`);
    }

    dispatch(uploadImageSuccessAction());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      "Failed to upload profile image",
    );
    dispatch(uploadImageFailure(message));
    return { success: false, error: message };
  } finally {
    isuploadProfileImage = false;
  }
};

export const removeProfileImage = (userId) => async (dispatch) => {
  if (isremoveProfileImage) return;
  isremoveProfileImage = true;
  dispatch(removeImageStart());
  try {
    await api.post(
      `${FILE_DELETE}?fileKey=${encodeURIComponent("user-images/" + userId)}`,
    );
    dispatch(removeImageSuccessAction());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      "Failed to remove profile image",
    );
    dispatch(removeImageFailure(message));
    return { success: false, error: message };
  } finally {
    isremoveProfileImage = false;
  }
};

// .................... Password ...........................

// export const confirmCurrentPassword = (email, password) => async (dispatch) => {
//   dispatch(confirmPasswordStart());
//   try {
//     await api.post(CONFIRM_PASSWORD, { email, password });
//     dispatch(confirmPasswordSuccessAction());
//     return { success: true };
//   } catch (error) {
//     const payload = error?.response?.data?.error || {
//       message: extractErrorMessage(error, "Invalid password"),
//     };
//     dispatch(confirmPasswordFailure(payload));
//     if (payload.message === "Account temporarily locked") {
//       dispatch(logoutUserAction());
//     }
//     return { success: false, error: payload };
//   }
// };

export const confirmCurrentPassword = (email, password) => async (dispatch) => {
  if (isconfirmCurrentPassword) return;
  isconfirmCurrentPassword = true;
  dispatch(confirmPasswordStart());
  try {
    await api.post(
      CONFIRM_PASSWORD,
      { email, password },
      { skipAuthRedirect: true },
    );
    dispatch(confirmPasswordSuccessAction());
    return { success: true };
  } catch (error) {
    const payload = error?.response?.data?.error || {
      message: extractErrorMessage(error, "Invalid password"),
    };
    dispatch(confirmPasswordFailure(payload));
    if (payload.message === "Account temporarily locked") {
      dispatch(logoutUserAction());
    }
    return { success: false, error: payload };
  } finally {
    isconfirmCurrentPassword = false;
  }
};

export const changePassword = (email, newPassword) => async (dispatch) => {
  if (ischangePassword) return;
  ischangePassword = true;
  dispatch(changePasswordStart());
  try {
    await api.post(SET_PASSWORD, { email, newPassword });
    dispatch(changePasswordSuccessAction());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to change password");
    dispatch(changePasswordFailure(message));
    return { success: false, error: message };
  } finally {
    ischangePassword = false;
  }
};

export const resetSettingsPasswordFlow = () => (dispatch) => {
  dispatch(resetPasswordFlow());
};
